import firebase from 'firebase/app';
import firestore from 'firebase/firestore';

// Initialize Firebase
var config = {
  apiKey: "AIzaSyARU-9gCRlijXUplYUgAtQ8wy16ddADccg",
  authDomain: "yolofitclub-vue.firebaseapp.com",
  databaseURL: "https://yolofitclub-vue.firebaseio.com",
  projectId: "yolofitclub-vue",
  storageBucket: "yolofitclub-vue.appspot.com",
  messagingSenderId: "409461975513"
};

const firebaseApp = firebase.initializeApp(config);
firebaseApp.firestore().settings({
  timestampsInSnapshots: true
});

export default firebaseApp.firestore();
